const allProductData = [
  {
    id: 1,
    name: "Selene Maxi Dress",
    category: "Dresses",
    price: "158.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.webp",
    images: ["/img/101.webp", "/img/101a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Light Blue", "Grey"],
    material: "98% Cotton, 2% Spandex — soft woven blend with gentle stretch",
    description: [
      "The Selene Maxi Dress is an effortless floor-grazing silhouette crafted from a breathable cotton-spandex blend that moves with you all day long.",
      "Its fitted bodice transitions into a relaxed, bias-cut skirt that skims the hips and drapes beautifully, creating soft movement with every step.",
      "Finished with delicate adjustable spaghetti straps, a subtle scoop neckline, and a graceful side slit for easy mobility.",
      "The lightweight fabric keeps you cool on warm afternoons while the longer length transitions effortlessly from daytime errands to evening dinners.",
      "An instant wardrobe staple that layers perfectly under a denim jacket or stands alone as a statement piece for any occasion.",
    ],
    Features: [
      "Bias-cut maxi silhouette with graceful drape",
      "Fitted bodice with invisible back zip closure",
      "Adjustable spaghetti straps for a custom fit",
      "Side slit for ease of movement",
      "Soft cotton-spandex blend — machine washable",
      "Fully lined bodice for added comfort",
      "Versatile enough for casual, work, and evening wear",
    ],
  },
  {
    id: 2,
    name: "Stu Linen Resort Shirt",
    category: "Shirts",
    price: "128.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp", "/img/102a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Cream", "Natural"],
    material: "55% Linen, 45% Cotton — pre-washed for softness",
    description: [
      "The Stu Linen Resort Shirt channels easy California coastal living with a relaxed, open-collar design made for warm-weather adventures.",
      "Cut from a premium linen-cotton blend that gets softer with every wash, this shirt features a lightweight, breathable weave ideal for sunny afternoons.",
      "A curved hemline allows you to wear it untucked over swimwear or alone as a lightweight overshirt during breezy evenings.",
      "Thoughtful details include a single chest patch pocket, mother-of-pearl-style buttons, and a box pleat at the back yoke for unrestricted movement.",
      "Designed to look effortlessly put-together whether you're exploring a new city or lounging at a beachside café.",
    ],
    Features: [
      "Open-collar resort silhouette with relaxed fit",
      "Lightweight linen-cotton blend — ideal for warm weather",
      "Single chest patch pocket with Mother-of-Pearl-style buttons",
      "Curved hemline for untucked wear",
      "Back yoke pleat for added movement and breathability",
      "Machine washable — gets softer with every cycle",
      "Perfect over swim trunks, shorts, or light trousers",
    ],
  },
  {
    id: 3,
    name: "Bonnie Poplin Shirt",
    category: "Shirts",
    price: "118.00",
    justLandedFeatured: true,
    reviews: "214",
    rating: "4.5",
    image: "/img/103.webp",
    images: ["/img/103.webp", "/img/103a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Light Blue"],
    material: "100% Cotton Poplin — crisp and lightweight",
    description: [
      "The Bonnie Poplin Shirt delivers polished sophistication in a fresh, clean cotton poplin that feels crisp against the skin.",
      "Its tailored silhouette features a spread collar, a button-down front, and a boxy fit that works tucked into high-waisted trousers or left loose for an effortless look.",
      "Poplin's tightly woven cotton construction offers a refined, slightly crisp hand feel that softens beautifully after washing.",
      "Mother-of-pearl-style buttons, a single chest pocket, and clean single-button cuffs keep the design minimal yet refined.",
      "A versatile wardrobe hero that carries you from the office to weekend brunches without missing a beat.",
    ],
    Features: [
      "Crisp 100% cotton poplin with a clean, polished hand feel",
      "Spread collar with button-down front",
      "Boxy, slightly oversized silhouette — flattering on all body types",
      "Single chest pocket and single-button cuffs",
      "Curved hem — designed to look great tucked or untucked",
      "Machine washable for easy care",
    ],
  },
  {
    id: 4,
    name: '6" Saturday Beach Short',
    category: "Shorts",
    price: "88.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp", "/img/104a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Tan", "Khaki"],
    material: "95% Nylon, 5% Spandex — quick-dry performance blend",
    description: [
      'The 6" Saturday Beach Short is your go-to for every sun-soaked moment — from morning surfs to afternoon margaritas by the shore.',
      "Crafted from a quick-dry nylon-spandex blend, these shorts shed water in seconds and dry fast enough to take you from the ocean to the boardwalk without skipping a beat.",
      "A comfortable elastic waistband with an internal drawcord provides a secure, adjustable fit that moves with you through any activity.",
      "Deep side pockets and a subtle rear zip pocket offer plenty of room for essentials like your phone, keys, and a travel card.",
      'The versatile 6" inseam hits above the knee for a clean, sporty look that pairs effortlessly with tees, tanks, or a breezy linen shirt.',
    ],
    Features: [
      "Quick-dry nylon-spandex blend for water and active use",
      "Comfortable elastic waistband with internal drawcord",
      "Deep side pockets and a rear zip pocket for secure storage",
      '6" inseam — clean and sporty above the knee',
      "Lightweight construction — easy to pack for travel",
      "Machine washable",
    ],
  },
  {
    id: 5,
    name: "Nell Midi Dress",
    category: "Dresses",
    price: "158.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp", "/img/105a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy Print"],
    material: "95% Rayon, 5% Spandex — silky draping jersey",
    description: [
      "The Nell Midi Dress is the definition of effortless elegance — a fluid midi-length silhouette in a buttery rayon-spandex jersey that drapes like a dream.",
      "Its gentle V-neckline, flutter sleeves, and defined waist create a universally flattering shape that works for every body type.",
      "The midi length hits below the knee with subtle movement, making it equally appropriate for a garden party, a workday, or a relaxed dinner date.",
      "Rayon construction gives the fabric a luxurious, silk-like hand feel that falls gracefully without clinging, while a touch of spandex ensures comfortable all-day wear.",
      "Pairs beautifully with sneakers for a casual weekend look or dressed up with sandals and delicate jewelry for something more refined.",
    ],
    Features: [
      "Silky rayon-spandex jersey with a fluid, draping hand feel",
      "Gentle V-neckline and flutter sleeves for a feminine touch",
      "Defined waist with a self-tie belt for adjustable fit",
      "Midi length — below the knee with gentle movement",
      "Flattering on all body types — versatile for any occasion",
      "Machine washable for easy care",
    ],
  },
  {
    id: 6,
    name: "Skye Midi Dress",
    category: "Dresses",
    price: "158.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.webp",
    images: ["/img/106.webp", "/img/106a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Beige", "Khaki"],
    material: "100% Linen — breathable and relaxed",
    description: [
      "The Skye Midi Dress is a breezy linen dream that captures the essence of warm-weather ease with effortless California style.",
      "Cut from pure, breathable linen, this dress keeps you cool and comfortable even on the hottest days of the season.",
      "A smocked bodice with gentle gathering offers a flexible, forgiving fit that adapts to your shape, while the midi skirt flows softly with movement.",
      "Delicate straps are adjustable for a perfect fit, and the lightweight fabric makes this dress as comfortable as your favorite tee.",
      "Dress it down with espadrilles and a sun hat for a farmer's market morning, or elevate it with wedges and gold jewelry for sunset cocktails.",
    ],
    Features: [
      "100% breathable linen — perfect for warm weather",
      "Smocked bodice for a flexible, forgiving fit",
      "Flowing midi skirt with soft movement",
      "Adjustable straps for a custom fit",
      "Side pockets for everyday practicality",
      "Machine washable — linen softens beautifully with wear",
    ],
  },
  {
    id: 7,
    name: "Skye Mini Dress",
    category: "Dresses",
    price: "138.00",
    springBreakQuickView: true,
    reviews: "240",
    rating: "4.7",
    image: "/img/107.jpg",
    images: ["/img/107.jpg", "/img/107a.jpg"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy"],
    material: "68% Rayon, 32% Lyocell — silky soft Tencel blend",
    description: [
      "The Skye Mini Dress is a playful, above-the-knee silhouette crafted from an ultra-soft rayon-Tencel blend that feels incredible against the skin.",
      "A flattering square neckline, adjustable straps, and a gently gathered waistband create a feminine shape that works for a wide range of occasions.",
      "The mini length keeps things light and breezy, while the fluid fabric drapes beautifully without feeling clingy.",
      "Lyocell content gives the fabric a sustainable, silky finish that gets better with every wash.",
      "This is the dress you reach for when you want to look put-together with minimal effort — just add your favorite sandals and a tote bag.",
    ],
    Features: [
      "Ultra-soft rayon-Tencel blend with a silky hand feel",
      "Flattering square neckline and adjustable straps",
      "Gathered waistband for a feminine silhouette",
      "Mini length — breezy and playful",
      "Sustainable Tencel construction",
      "Machine washable",
    ],
  },
  {
    id: 8,
    name: "Corinne Maxi Dress",
    category: "Dresses",
    price: "128.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.jpg",
    images: ["/img/108.jpg", "/img/108a.jpg"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Light Grey", "White"],
    material: "100% Washed Linen — soft and relaxed",
    description: [
      "The Corinne Maxi Dress brings together the ease of resort dressing with the elegance of a floor-grazing silhouette in pre-washed, buttery-soft linen.",
      "A deep V-neckline and an open midriff cut-out add a subtle, sophisticated touch of skin that keeps the look modern rather than conservative.",
      "The relaxed, oversized fit drapes beautifully over your frame, while the adjustable tie-waist lets you control the level of structure.",
      "Pockets are hidden in the side seams — a practical detail you didn't know you needed until you had it.",
      "Linen's natural breathability makes this dress a go-to for beach weddings, vineyard tours, or any warm-weather event where you want to look effortlessly chic.",
    ],
    Features: [
      "Pre-washed 100% linen — buttery soft from day one",
      "Deep V-neckline with midriff cut-out detail",
      "Adjustable tie-waist for a customizable silhouette",
      "Hidden side-seam pockets",
      "Relaxed, oversized fit with floor-grazing length",
      "Machine washable",
    ],
  },
  {
    id: 9,
    name: "Relaxed Hemp Cotton Graphic Tee",
    category: "Tees",
    price: "58.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp", "/img/109a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["White", "Cream"],
    material: "55% Hemp, 45% Organic Cotton — naturally durable blend",
    description: [
      "The Relaxed Hemp Cotton Graphic Tee is where laid-back California style meets serious sustainability — made with a hemp-cotton blend that feels as good as it looks.",
      "A relaxed, boxy fit and dropped shoulders create a comfortable, modern silhouette that works for everyone.",
      "Hemp is naturally more durable and breathable than conventional cotton, meaning this tee will hold its shape and color wash after wash.",
      "Featuring a front chest screen print with one of Marine Layer's signature surf-inspired designs in a soft-hand discharge ink.",
      "The perfect everyday essential that you can feel good about — better for the planet, better for your wardrobe.",
    ],
    Features: [
      "55% hemp, 45% organic cotton — naturally breathable and durable",
      "Relaxed, boxy fit with dropped shoulders",
      "Screen-printed chest graphic in soft discharge ink",
      "Hemp gets softer and more comfortable with every wash",
      "Reinforced collar that resists stretching",
      "Machine washable",
    ],
  },
  {
    id: 10,
    name: "Allison Hemp Trouser",
    category: "Pants",
    price: "118.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.webp",
    images: ["/img/1010.webp", "/img/1010a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Natural Stripe"],
    material: "53% Hemp, 44% Cotton, 3% Spandex — structured stretch blend",
    description: [
      "The Allison Hemp Trouser is a refined wide-leg pant that brings together sustainability, comfort, and a tailored look that works in almost any setting.",
      "Cut from a hemp-cotton-spandex blend, these trousers offer just the right amount of stretch for all-day comfort without sacrificing structure.",
      "A high-rise waist with a wide waistband and a hidden side-seam zip closure creates a clean, polished front, while the full-length wide leg elongates the silhouette.",
      "Side pockets are deep enough to hold your phone comfortably, and the hem is finished with a subtle turnover for durability.",
      "Dress them up with a tucked blouse and heels for the office, or pair with sneakers and a relaxed tee for a casual weekend look.",
    ],
    Features: [
      "High-rise wide-leg silhouette that elongates the figure",
      "Structured hemp-cotton blend with gentle stretch",
      "Side-seam zip closure for a clean front",
      "Deep side pockets and finished hem",
      "Wrinkle-resistant — great for travel",
      "Machine washable",
    ],
  },
  {
    id: 11,
    name: "Mara Hemp Tank",
    category: "Tops",
    price: "88.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp", "/img/1011a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Natural Stripe"],
    material: "70% Hemp, 30% Organic Cotton — lightweight and airy",
    description: [
      "The Mara Hemp Tank is the ultimate warm-weather essential — a relaxed-fit tank in a lightweight hemp-cotton blend that keeps you cool and comfortable all day.",
      "A slightly wider shoulder strap and a subtle scoop neckline create a universally flattering shape that works alone or as a layering piece.",
      "Hemp's natural breathability and moisture-wicking properties make this tank ideal for hot yoga, coastal hikes, lazy Sundays, or any sun-filled day.",
      "The relaxed fit drapes softly without clinging, and the fabric gets softer and more comfortable with every single wash.",
      "Pairs effortlessly with the Allison Hemp Trouser, your favorite denim, or worn under an open linen shirt for a layered, effortless look.",
    ],
    Features: [
      "Relaxed-fit silhouette — comfortable and universally flattering",
      "70% hemp blend — naturally breathable and quick-drying",
      "Slightly wider straps and a gentle scoop neckline",
      "Fabric softens beautifully with each wash",
      "Great for layering or wearing on its own",
      "Machine washable",
    ],
  },
  {
    id: 12,
    name: "Better-Than-Linen Long Sleeve Shirt",
    category: "Shirts",
    price: "138.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp", "/img/1012a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Floral Print"],
    material: "49% Rayon, 48% Polyester, 3% Spandex — silky stretch fabric",
    description: [
      "The Better-Than-Linen Long Sleeve Shirt delivers the refined, relaxed look of linen without the wrinkles — in a silky rayon-polyester blend that always looks polished.",
      "A spread collar, full-button front, and fitted silhouette create a sophisticated shape that transitions seamlessly from desk to dinner.",
      "The fabric has a subtle sheen and fluid drape that feels more luxurious than traditional linen while being far easier to care for.",
      "Long sleeves with button cuffs and a slight cap sleeve finish give it a polished, put-together feel that holds up all day long.",
      "A true wardrobe workhorse that looks sharp whether you're wearing it tucked into trousers, half-tucked over denim, or layered under a sweater.",
    ],
    Features: [
      "Rayon-polyester-spandex blend — refined look without the wrinkles",
      "Spread collar and full-button front",
      "Slightly fitted silhouette with fluid drape",
      "Long sleeves with button cuffs",
      "Wrinkle-resistant — perfect for travel",
      "Machine washable",
    ],
  },
  {
    id: 13,
    name: "90s High Waisted Bottom",
    category: "Shorts",
    price: "58.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp", "/img/1013a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy Stripe"],
    material: "75% Cotton, 20% Polyester, 5% Spandex — vintage-washed denim",
    description: [
      "Channel your inner 90s icon with the 90s High Waisted Bottom — a vintage-inspired, ultra-high-rise short that sits at or above the natural waist.",
      "Crafted from a vintage-washed denim with a comfortable cotton-polyester-spandex blend, these shorts have the broken-in softness of a favorite pair you've worn for years.",
      "A zip fly with a single button, belt loops, and traditional jean pocket styling keep the look authentic, while the medium wash has subtle fading and whiskering.",
      "The straight-leg short inseam hits mid-thigh for that iconic 90s silhouette that goes with everything from crop tops to oversized tees.",
      "A fun, nostalgic addition to your warm-weather wardrobe that proves some trends are worth coming back to.",
    ],
    Features: [
      "Ultra-high-rise silhouette — sits at or above the natural waist",
      "Vintage-washed denim with authentic fading and whiskering",
      "Zip fly with single button and belt loops",
      "Mid-thigh inseam — iconic 90s length",
      "Traditional front and back jean pockets",
      "Machine washable",
    ],
  },
  {
    id: 14,
    name: "Hemp Bomber Jacket",
    category: "Jackets",
    price: "188.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp", "/img/1014a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Red Stripe"],
    material: "60% Hemp, 40% Organic Cotton — midweight and durable",
    description: [
      "The Hemp Bomber Jacket brings the iconic bomber silhouette into the sustainable future with a hemp-cotton shell and a soft, brushed fleece lining.",
      "A full-zip front with a ribbed collar, cuffs, and hem creates the classic bomber shape, while the midweight fabric makes it suitable for layering across multiple seasons.",
      "The slightly cropped length hits at the waist, making it ideal to pair with high-waisted jeans, skirts, or the Allison Hemp Trouser.",
      "Two side zip pockets and an interior zip chest pocket offer secure storage, while the fleece lining adds warmth and a cozy hand feel.",
      "A sustainable statement piece that proves you don't have to compromise style for sustainability — or vice versa.",
    ],
    Features: [
      "Classic bomber silhouette in a hemp-cotton shell",
      "Soft brushed fleece lining for warmth and comfort",
      "Full-zip front with ribbed collar, cuffs, and hem",
      "Two side zip pockets and an interior chest pocket",
      "Slightly cropped length — pairs perfectly with high-waisted styles",
      "Midweight — great for layering in spring, fall, and mild winters",
    ],
  },
  {
    id: 15,
    name: "Allison Hemp Crop Trouser",
    category: "Pants",
    price: "118.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.webp",
    images: ["/img/1015.webp", "/img/1015a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Red Stripe"],
    material: "53% Hemp, 44% Cotton, 3% Spandex — structured stretch blend",
    description: [
      "The Allison Hemp Crop Trouser takes the beloved wide-leg silhouette of its full-length sibling and trims it to a chic, ankle-skimming crop length.",
      "Crafted from the same durable hemp-cotton-spandex blend, these trousers offer structure with just enough stretch for all-day comfort.",
      "The cropped length makes them the perfect pairing with sneakers, espadrilles, or flat sandals, and works beautifully across all four seasons.",
      "A high-rise waist, side-seam zip closure, and deep side pockets keep the design clean and functional.",
      "Available in leopard print and a classic ivory, these trousers are proof that comfortable and chic are not mutually exclusive.",
    ],
    Features: [
      "Cropped wide-leg silhouette — ankle-skimming length",
      "High-rise waist with side zip closure",
      "Hemp-cotton-spandex blend — structured with gentle stretch",
      "Deep side pockets and turnover hem finish",
      "Pairs perfectly with sneakers, sandals, or espadrilles",
      "Machine washable",
    ],
  },
  {
    id: 16,
    name: "Santorini Bikini Top",
    category: "Swim",
    price: "76.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp", "/img/1016a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Pink Stripe"],
    material: "85% Recycled Nylon, 15% Spandex — sustainable swim fabric",
    description: [
      "The Santorini Bikini Top is a timeless, convertible triangle-style swim top designed for comfort, support, and sun-soaked days by the water.",
      "Crafted from a smooth recycled nylon-spandex blend that offers four-way stretch, chlorine resistance, and UV protection.",
      "Adjustable straps and a tie-back closure allow you to customize the fit and level of support, while removable soft cups provide additional shaping.",
      "The clean, minimal design layers beautifully under sheer cover-ups and beach shirts, or stands alone as a stylish swimwear statement.",
      "Part of Marine Layer's Re-Spun swim collection, made with sustainable materials that reduce environmental impact without compromising on quality.",
    ],
    Features: [
      "Convertible triangle-style silhouette with adjustable fit",
      "85% recycled nylon — sustainable and chlorine-resistant",
      "Four-way stretch with UV protection",
      "Tie-back closure and adjustable straps",
      "Removable soft cups for customizable support",
      "Pairs perfectly with the Santorini Bikini Bottom",
    ],
  },
  {
    id: 17,
    name: "Rayna Hemp Tee",
    category: "Tees",
    price: "98.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Red", "Orange"],
    material: "55% Hemp, 45% Organic Cotton — medium-weight sustainable tee",
    description: [
      "The Rayna Hemp Tee is a classic crew-neck essential crafted from a medium-weight hemp-cotton blend that strikes the perfect balance between structure and softness.",
      "A relaxed, slightly boxy fit with a traditional crew neckline and short sleeves makes this the ultimate everyday tee.",
      "Hemp fibers add natural durability and a subtle texture to the fabric, while organic cotton keeps it soft against the skin.",
      "A front chest pocket adds a subtle detail that elevates this tee above the basic, and the reinforced collar maintains its shape wash after wash.",
      "The kind of tee you reach for every single day — available in timeless colors that belong in every wardrobe rotation.",
    ],
    Features: [
      "Relaxed, slightly boxy fit — comfortable and modern",
      "Classic crew neckline with short sleeves",
      "55% hemp, 45% organic cotton — naturally durable and soft",
      "Front chest pocket with subtle detail",
      "Reinforced collar that resists stretching",
      "Machine washable — gets better with every wash",
    ],
  },
  {
    id: 18,
    name: "Laguna One Piece",
    category: "Swim",
    price: "142.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.webp",
    images: ["/img/1018.webp", "/img/1018a.webp"],
    size: ["XS", "S", "M", "L"],
    colors: ["Navy"],
    material: "85% Recycled Nylon, 15% Spandex — sustainable swim fabric",
    description: [
      "The Laguna One Piece is a timeless, retro-inspired swim suit with a classic scoop neckline and a medium-high cut leg for a flattering, feminine silhouette.",
      "Made from a smooth recycled nylon-spandex blend with four-way stretch, chlorine resistance, and UPF 50+ sun protection.",
      "A soft shelf bra with built-in cups provides comfortable support for all-day wear, whether you're lounging poolside or taking a surf lesson.",
      "The figure-flattering cut narrows at the waist and elongates the leg, giving you a confident, put-together look in and out of the water.",
      "Part of Marine Layer's Re-Spun collection — crafted from recycled materials to minimize environmental impact.",
    ],
    Features: [
      "Classic scoop neckline with medium-high cut leg",
      "85% recycled nylon — chlorine-resistant with UPF 50+ protection",
      "Built-in soft cups for comfortable support",
      "Four-way stretch for unrestricted movement",
      "Flattering waist narrows and leg-elongating cut",
      "Machine washable",
    ],
  },
  {
    id: 19,
    name: "Corinne Maxi Dress",
    category: "Dresses",
    price: "128.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy"],
    material: "100% Washed Linen — buttery soft and relaxed",
    description: [
      "This second iteration of the Corinne Maxi Dress arrives in new colorways — the same dreamy, floor-grazing silhouette in pre-washed, buttery-soft linen.",
      "A deep V-neckline and open midriff cut-out add a sophisticated touch, while the adjustable tie-waist lets you customize the silhouette from relaxed to refined.",
      "The pure linen construction is naturally breathable and gets softer with every wash, making it better with age.",
      "Hidden side pockets are seamlessly integrated into the design — a detail that will quickly become your favorite.",
      "Whether you're attending an outdoor wedding, a beachside dinner, or a farmer's market stroll, this dress has you covered in effortless style.",
    ],
    Features: [
      "Pre-washed 100% linen — buttery soft and breathable",
      "Deep V-neckline with midriff cut-out",
      "Adjustable tie-waist for a customizable fit",
      "Hidden side-seam pockets",
      "Floor-grazing maxi length",
      "Machine washable",
    ],
  },
  {
    id: 20,
    name: "Marisol Poplin Boxer Short",
    category: "Shorts",
    price: "88.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp", "/img/1020a.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Gingham", "Plaid"],
    material: "100% Cotton Poplin — crisp and lightweight",
    description: [
      "The Marisol Poplin Boxer Short brings menswear-inspired sophistication to women's wardrobes in a crisp, airy cotton poplin.",
      "A high-waisted, wide-leg silhouette with an elastic back waistband and a functional front fly button creates the perfect combination of comfort and style.",
      "Crafted from lightweight cotton poplin with a crisp hand feel, these shorts are perfect for warm-weather days when you want something more polished than denim.",
      "Subtle pin-tuck details at the front add a refined touch, while deep side pockets keep essentials close at hand.",
      "Available in classic black with gunmetal hardware and a soft blush, these shorts transition effortlessly from a casual beach walk to a smart-casual dinner.",
    ],
    Features: [
      "High-waisted, wide-leg boxer silhouette",
      "Elastic back waistband with functional front fly button",
      "Crisp 100% cotton poplin — lightweight and breathable",
      "Pin-tuck front details for a refined finish",
      "Deep side pockets and a subtle back pocket",
      "Machine washable",
    ],
  },
  {
    id: 21,
    name: "Low-Top Merlot",
    category: "Shoes & Boots",
    price: "175.00",
    images: ["/img/generated-shoes/shoe-21-low-top-merlot.png"],
    description: [
      "A burgundy low-top sneaker with subtle floral embroidery. Its flexible sole and padded collar provide everyday comfort.",
    ],
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "Runs slightly small",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["Burgundy"],
    tags: ["sneakers", "embroidered", "low-top"],
    badge: "New",
    rating: "4.8",
    reviews: "84",
    image: "/img/generated-shoes/shoe-21-low-top-merlot.png",
    material: "Microfibre and textile",
    Features: [
      "Sole: Rubber",
      "Fit: Runs slightly small",
      "Origin: See product label",
    ],
  },
  {
    id: 22,
    name: "Court White",
    category: "Shoes & Boots",
    price: "180.00",
    images: ["/img/generated-shoes/shoe-22-court-white.png"],
    description: [
      "A clean white sneaker with a caramel accent panel. An easy-to-style silhouette with a cushioned insole.",
    ],
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["White", "Caramel"],
    tags: ["sneakers", "white", "everyday"],
    rating: "4.7",
    reviews: "62",
    image: "/img/generated-shoes/shoe-22-court-white.png",
    material: "Microfibre and textile",
    Features: [
      "Sole: Rubber",
      "Fit: True to size",
      "Origin: See product label",
    ],
  },
  {
    id: 23,
    name: "Court Black",
    category: "Shoes & Boots",
    price: "180.00",
    images: ["/img/generated-shoes/shoe-23-court-black.png"],
    description: [
      "A minimalist black sneaker on a cream sole. Its understated profile works with both casual and smarter looks.",
    ],
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["Black", "Cream"],
    tags: ["sneakers", "black", "minimalist"],
    rating: "4.7",
    reviews: "58",
    image: "/img/generated-shoes/shoe-23-court-black.png",
    material: "Microfibre and textile",
    Features: [
      "Sole: Rubber",
      "Fit: True to size",
      "Origin: See product label",
    ],
  },
  {
    id: 24,
    name: "Retro Hazel",
    category: "Shoes & Boots",
    price: "195.00",
    images: ["/img/generated-shoes/shoe-24-retro-hazel.png"],
    description: [
      "A retro-inspired sneaker with hazel and plum panels. Its dynamic profile and light cushioning suit long days.",
    ],
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: [
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
    ],
    colors: ["Hazel", "Plum"],
    tags: ["sneakers", "retro", "unisex"],
    badge: "Best-seller",
    rating: "4.9",
    reviews: "105",
    image: "/img/generated-shoes/shoe-24-retro-hazel.png",
    material: "Microfibre and textile",
    Features: [
      "Sole: Rubber",
      "Fit: True to size",
      "Origin: See product label",
    ],
  },
  {
    id: 25,
    name: "City Loafer Cocoa",
    category: "Shoes & Boots",
    price: "190.00",
    images: ["/img/generated-shoes/shoe-25-city-loafer-cocoa.png"],
    description: [
      "A chocolate loafer with a lug sole, designed to combine support, stability and a city-ready look.",
    ],
    attributes: {
      material: "Velvet-effect microfibre",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["Chocolate"],
    tags: ["loafer", "urban", "lug sole"],
    rating: "4.6",
    reviews: "43",
    image: "/img/generated-shoes/shoe-25-city-loafer-cocoa.png",
    material: "Velvet-effect microfibre",
    Features: [
      "Sole: Rubber",
      "Fit: True to size",
      "Origin: See product label",
    ],
  },
  {
    id: 26,
    name: "Polished Derby",
    category: "Shoes & Boots",
    price: "205.00",
    images: ["/img/generated-shoes/shoe-26-polished-derby.png"],
    description: [
      "A polished black Derby with clean lines. The substantial sole and low heel create a stable base without weighing down the silhouette.",
    ],
    attributes: {
      material: "Coated microfibre",
      origin: "See product label",
      sole: "Rubber",
      fit: "Runs slightly large",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["Glossy black"],
    tags: ["derby", "glossy", "city"],
    rating: "4.8",
    reviews: "39",
    image: "/img/generated-shoes/shoe-26-polished-derby.png",
    material: "Coated microfibre",
    Features: [
      "Sole: Rubber",
      "Fit: Runs slightly large",
      "Origin: See product label",
    ],
  },
  {
    id: 27,
    name: "Block Heel Amber",
    category: "Shoes & Boots",
    price: "210.00",
    images: ["/img/generated-shoes/shoe-27-block-heel-amber.png"],
    description: [
      "An amber ankle boot built around a block heel. A side fastening makes it easy to put on, while the rounded toe adds room.",
    ],
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["Amber"],
    tags: ["ankle boot", "block heel", "city"],
    badge: "Featured",
    compareAtPrice: 220,
    rating: "4.7",
    reviews: "51",
    image: "/img/generated-shoes/shoe-27-block-heel-amber.png",
    material: "Microfibre",
    Features: [
      "Sole: Non-slip rubber",
      "Fit: True to size",
      "Origin: See product label",
    ],
  },
  {
    id: 28,
    name: "Round-Toe Wine",
    category: "Shoes & Boots",
    price: "185.00",
    images: ["/img/generated-shoes/shoe-28-round-toe-wine.png"],
    description: [
      "A burgundy strap shoe with a stable heel and rounded toe. A versatile style for day or evening.",
    ],
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: ["35", "36", "37", "38", "39", "40", "41", "42"],
    colors: ["Burgundy"],
    tags: ["strap", "heel", "smart"],
    rating: "4.8",
    reviews: "47",
    image: "/img/generated-shoes/shoe-28-round-toe-wine.png",
    material: "Microfibre",
    Features: [
      "Sole: Non-slip rubber",
      "Fit: True to size",
      "Origin: See product label",
    ],
  },
  {
    id: 29,
    name: "Flex Sage",
    category: "Shoes & Boots",
    price: "175.00",
    images: ["/img/generated-shoes/shoe-29-flex-sage.png"],
    description: [
      "A flexible sage sneaker with a wide toe box, designed to provide extra room and support natural foot movement.",
    ],
    attributes: {
      material: "Breathable textile and microfibre",
      origin: "See product label",
      sole: "Slim and flexible",
      fit: "Wide fit",
    },
    size: [
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
    ],
    colors: ["Sage"],
    tags: ["flexible", "unisex", "wide"],
    badge: "New",
    rating: "4.7",
    reviews: "29",
    image: "/img/generated-shoes/shoe-29-flex-sage.png",
    material: "Breathable textile and microfibre",
    Features: [
      "Sole: Slim and flexible",
      "Fit: Wide fit",
      "Origin: See product label",
    ],
  },
];

const footwearVariantSpecs = [
  {
    id: 30,
    baseId: 21,
    name: "Low-Top Merlot Bloom",
    image: "/img/generated-shoes/shoe-30-low-top-merlot-bloom.png",
    images: ["/img/generated-shoes/shoe-30-low-top-merlot-bloom.png"],
    price: "179.00",
    colors: ["Burgundy", "Cream"],
    description:
      "A floral-accented burgundy sneaker with a soft padded collar and flexible everyday sole.",
  },
  {
    id: 31,
    baseId: 22,
    name: "Court Sand",
    image: "/img/generated-shoes/shoe-31-court-sand.png",
    images: ["/img/generated-shoes/shoe-31-court-sand.png"],
    price: "180.00",
    colors: ["Cream", "Caramel"],
    description:
      "A warm neutral court sneaker designed for easy styling and cushioned everyday comfort.",
  },
  {
    id: 32,
    baseId: 22,
    name: "Court Navy",
    image: "/img/generated-shoes/shoe-32-court-navy.png",
    images: ["/img/generated-shoes/shoe-32-court-navy.png"],
    price: "185.00",
    colors: ["Navy", "White"],
    description:
      "A navy court sneaker with crisp contrast details and a supportive cushioned insole.",
  },
  {
    id: 33,
    baseId: 24,
    name: "Retro Moss",
    image: "/img/generated-shoes/shoe-33-retro-moss.png",
    images: ["/img/generated-shoes/shoe-33-retro-moss.png"],
    price: "195.00",
    colors: ["Sage", "Hazel"],
    description:
      "A retro runner in earthy moss tones, finished with light cushioning for long days on foot.",
  },
  {
    id: 34,
    baseId: 24,
    name: "Retro Plum",
    image: "/img/generated-shoes/shoe-34-retro-plum.png",
    images: ["/img/generated-shoes/shoe-34-retro-plum.png"],
    price: "198.00",
    colors: ["Plum", "Cream"],
    description:
      "A plum-toned retro sneaker with layered panels and a comfortable, balanced profile.",
  },
  {
    id: 35,
    baseId: 25,
    name: "City Loafer Black",
    image: "/img/generated-shoes/shoe-35-city-loafer-black.png",
    images: ["/img/generated-shoes/shoe-35-city-loafer-black.png"],
    price: "190.00",
    colors: ["Black"],
    description:
      "A black city loafer with a stable lug sole and a clean silhouette for work or weekends.",
  },
  {
    id: 36,
    baseId: 25,
    name: "City Loafer Wine",
    image: "/img/generated-shoes/shoe-36-city-loafer-wine.png",
    images: ["/img/generated-shoes/shoe-36-city-loafer-wine.png"],
    price: "195.00",
    colors: ["Burgundy"],
    description:
      "A rich wine loafer that pairs a polished upper with a supportive, city-ready sole.",
  },
  {
    id: 37,
    baseId: 26,
    name: "Polished Derby Oxblood",
    image: "/img/generated-shoes/shoe-37-polished-derby-oxblood.png",
    images: ["/img/generated-shoes/shoe-37-polished-derby-oxblood.png"],
    price: "210.00",
    colors: ["Burgundy"],
    description:
      "An oxblood Derby with refined lines, a substantial sole, and a stable low heel.",
  },
  {
    id: 38,
    baseId: 26,
    name: "Polished Derby Espresso",
    image: "/img/generated-shoes/shoe-38-polished-derby-espresso.png",
    images: ["/img/generated-shoes/shoe-38-polished-derby-espresso.png"],
    price: "210.00",
    colors: ["Chocolate"],
    description:
      "A deep espresso Derby designed with understated shine and dependable everyday structure.",
  },
  {
    id: 39,
    baseId: 27,
    name: "Block Heel Black",
    image: "/img/generated-shoes/shoe-39-block-heel-black.png",
    images: ["/img/generated-shoes/shoe-39-block-heel-black.png"],
    price: "215.00",
    colors: ["Black"],
    description:
      "A black ankle boot with a grounded block heel, rounded toe, and convenient side fastening.",
  },
  {
    id: 40,
    baseId: 27,
    name: "Block Heel Wine",
    image: "/img/generated-shoes/shoe-40-block-heel-wine.png",
    images: ["/img/generated-shoes/shoe-40-block-heel-wine.png"],
    price: "215.00",
    colors: ["Burgundy"],
    description:
      "A wine-toned ankle boot combining a stable block heel with a comfortable rounded toe.",
  },
  {
    id: 41,
    baseId: 28,
    name: "Round-Toe Black",
    image: "/img/generated-shoes/shoe-41-round-toe-black.png",
    images: ["/img/generated-shoes/shoe-41-round-toe-black.png"],
    price: "188.00",
    colors: ["Black"],
    description:
      "A versatile black strap shoe with a rounded toe and stable heel for day-to-evening wear.",
  },
  {
    id: 42,
    baseId: 28,
    name: "Round-Toe Amber",
    image: "/img/generated-shoes/shoe-42-round-toe-amber.png",
    images: ["/img/generated-shoes/shoe-42-round-toe-amber.png"],
    price: "188.00",
    colors: ["Amber"],
    description:
      "An amber strap shoe with a comfortable rounded toe and a balanced, easy-wearing heel.",
  },
  {
    id: 43,
    baseId: 29,
    name: "Flex Stone",
    image: "/img/generated-shoes/shoe-43-flex-stone.png",
    images: ["/img/generated-shoes/shoe-43-flex-stone.png"],
    price: "175.00",
    colors: ["Grey", "Cream"],
    description:
      "A stone-toned flexible sneaker with a wider toe box that supports natural movement.",
  },
  {
    id: 44,
    baseId: 29,
    name: "Flex Navy",
    image: "/img/generated-shoes/shoe-44-flex-navy.png",
    images: ["/img/generated-shoes/shoe-44-flex-navy.png"],
    price: "178.00",
    colors: ["Navy"],
    description:
      "A breathable navy sneaker with a flexible slim sole and extra room through the toe box.",
  },
  {
    id: 45,
    baseId: 29,
    name: "Trail Sage",
    image: "/img/generated-shoes/shoe-45-trail-sage.png",
    images: ["/img/generated-shoes/shoe-45-trail-sage.png"],
    price: "185.00",
    colors: ["Sage", "Cream"],
    description:
      "A lightweight sage walking sneaker shaped for flexible support across everyday routes.",
  },
  {
    id: 46,
    baseId: 21,
    name: "Trail Burgundy",
    image: "/img/generated-shoes/shoe-46-trail-burgundy.png",
    images: ["/img/generated-shoes/shoe-46-trail-burgundy.png"],
    price: "185.00",
    colors: ["Burgundy"],
    description:
      "A burgundy walking sneaker with secure lacing, a padded collar, and a flexible rubber sole.",
  },
  {
    id: 47,
    baseId: 22,
    name: "Everyday Cream",
    image: "/img/generated-shoes/shoe-47-everyday-cream.png",
    images: ["/img/generated-shoes/shoe-47-everyday-cream.png"],
    price: "175.00",
    colors: ["Cream", "White"],
    description:
      "A clean cream sneaker with tonal details and cushioning suited to everyday wear.",
  },
  {
    id: 48,
    baseId: 23,
    name: "Everyday Rose",
    image: "/img/generated-shoes/shoe-48-everyday-rose.png",
    images: ["/img/generated-shoes/shoe-48-everyday-rose.png"],
    price: "180.00",
    colors: ["Burgundy", "Cream"],
    description:
      "A muted rose everyday sneaker with a minimal profile and comfortable rubber sole.",
  },
  {
    id: 49,
    baseId: 27,
    name: "City Chelsea Cocoa",
    image: "/img/generated-shoes/shoe-49-city-chelsea-cocoa.png",
    images: ["/img/generated-shoes/shoe-49-city-chelsea-cocoa.png"],
    price: "220.00",
    colors: ["Chocolate"],
    description:
      "A cocoa ankle boot with a city-ready profile, stable heel, and easy side fastening.",
  },
  {
    id: 50,
    baseId: 27,
    name: "City Chelsea Black",
    image: "/img/generated-shoes/shoe-50-city-chelsea-black.png",
    images: ["/img/generated-shoes/shoe-50-city-chelsea-black.png"],
    price: "220.00",
    colors: ["Black"],
    description:
      "A streamlined black ankle boot with a supportive sole and an easy everyday fit.",
  },
];

const footwearEditorial = {
  21: {
    lead: "A refined burgundy low-top that brings depth and texture to an everyday sneaker silhouette.",
    design: "Merlot microfibre suede is balanced with woven side panels, tonal stitching and a clean cream foxing line for a quietly distinctive finish.",
    wear: "A padded collar and lightly cushioned footbed keep it comfortable from weekday commutes to relaxed weekends.",
    material: "Microfibre suede, recycled woven textile and soft recycled-polyester lining",
    sole: "Flexible cream rubber cupsole with textured grip",
    fit: "Runs slightly small; choose the next size up for a relaxed fit",
    highlights: ["Removable cushioned footbed", "Reinforced toe and heel panels"],
  },
  22: {
    lead: "A clean white court sneaker designed as an easy foundation for year-round dressing.",
    design: "Smooth microfibre panels, a perforated toe and a warm beige heel tab give the minimal profile subtle definition without visible branding.",
    wear: "Balanced cushioning and a stable cupsole make it a dependable choice for daily walking and long travel days.",
    material: "Smooth microfibre upper with breathable textile lining",
    sole: "Stitched off-white rubber court sole",
    fit: "True to size with a regular-width toe box",
    highlights: ["Perforated toe for airflow", "Padded tongue and ankle collar"],
  },
  23: {
    lead: "A black court sneaker with a gum sole and an understated, city-ready attitude.",
    design: "Matte panels meet soft suede-effect accents at the heel, while tonal laces keep the look streamlined and versatile.",
    wear: "The supportive footbed and grippy outsole transition easily from office commutes to evening plans.",
    material: "Matte microfibre and suede-effect microfibre with textile lining",
    sole: "Caramel gum-rubber cupsole",
    fit: "True to size; secure through the midfoot",
    highlights: ["Cushioned heel insert", "Durable gum-rubber tread"],
  },
  24: {
    lead: "A hazel-toned retro runner that combines seventies styling with modern underfoot comfort.",
    design: "Layered suede-effect overlays, open mesh panels and a sculpted cream sole create a dynamic profile with rich earthy contrast.",
    wear: "Lightweight foam cushioning softens long days on foot while the heel counter adds reassuring stability.",
    material: "Suede-effect microfibre and breathable recycled mesh",
    sole: "Sculpted EVA midsole with rubber traction pods",
    fit: "True to size with a softly structured heel",
    highlights: ["Shock-absorbing foam midsole", "Breathable mesh underlays"],
  },
  25: {
    lead: "A cocoa penny loafer that pairs polished tailoring with a confident lightweight lug sole.",
    design: "Apron stitching and a softly rounded toe preserve the classic character, while the ridged outsole gives it a contemporary city profile.",
    wear: "A padded heel cup and flexible forefoot make it comfortable enough for workdays, dinners and weekend errands.",
    material: "Grained microfibre upper with smooth recycled-textile lining",
    sole: "Lightweight black rubber lug sole",
    fit: "True to size; slightly generous at the toe",
    highlights: ["Padded heel cup", "Flexible forefoot construction"],
  },
  26: {
    lead: "A polished Derby built around clean proportions, an almond toe and dependable structure.",
    design: "Five-eyelet lacing and restrained seam work keep the silhouette formal, while the substantial outsole adds a modern grounded finish.",
    wear: "A cushioned insole and flexible front section support comfortable wear through meetings, events and evenings out.",
    material: "Polished coated microfibre with breathable textile lining",
    sole: "Welt-effect rubber sole with low stacked heel",
    fit: "Runs slightly large; consider one size down",
    highlights: ["Cushioned removable insole", "Reinforced heel counter"],
  },
  27: {
    lead: "An amber ankle boot with a strong block heel and a softly rounded, easy-wearing toe.",
    design: "Minimal seam lines and a tonal side zip keep the warm colour and architectural heel at the centre of the design.",
    wear: "The broad heel distributes weight evenly, while the padded footbed supports comfortable day-to-evening dressing.",
    material: "Smooth microfibre upper with soft brushed textile lining",
    sole: "Non-slip rubber outsole with stable wrapped block heel",
    fit: "True to size with a regular ankle opening",
    highlights: ["Easy inside zip fastening", "Balanced wide block heel"],
  },
  28: {
    lead: "A wine-red Mary Jane that blends a classic rounded toe with a modern low heel.",
    design: "A slender adjustable strap frames the foot, while the rich matte finish gives the silhouette a refined, versatile character.",
    wear: "Soft lining and forefoot cushioning make it suited to celebrations, dinners and polished everyday outfits.",
    material: "Matte microfibre upper with smooth recycled lining",
    sole: "Flexible non-slip rubber sole with low flared heel",
    fit: "True to size; adjustable instep strap",
    highlights: ["Adjustable metal buckle", "Cushioned forefoot pad"],
  },
  29: {
    lead: "A sage knitted sneaker shaped to let the foot move naturally throughout the day.",
    design: "The wide anatomical toe box, seamless knit body and low flexible sole create a light, barely-there profile.",
    wear: "Breathable construction and a removable footbed make it ideal for travel, gentle training and everyday walking.",
    material: "Breathable recycled knit with microfibre reinforcement",
    sole: "Slim segmented rubber sole for natural flex",
    fit: "Wide fit; true to size in length",
    highlights: ["Wide anatomical toe box", "Seam-minimised knitted upper"],
  },
  30: {
    lead: "A floral-accented evolution of the Merlot low-top, finished in layered burgundy tones.",
    design: "Tonal botanical embroidery adds dimension to the side panels while a cream collar and sole keep the palette balanced.",
    wear: "Gentle ankle padding and a flexible cupsole provide familiar sneaker comfort without losing the elevated finish.",
    material: "Embroidered microfibre suede, woven textile and recycled lining",
    sole: "Flexible cream rubber cupsole",
    fit: "Runs slightly small; size up for more toe room",
    highlights: ["Tonal botanical embroidery", "Soft padded collar"],
  },
  31: {
    lead: "A warm neutral court sneaker combining sand, caramel and cream for effortless everyday styling.",
    design: "Soft suede-effect overlays frame a smooth upper and perforated toe, creating depth while keeping the profile clean.",
    wear: "Moderate cushioning and a durable gum edge make it comfortable for regular city use.",
    material: "Smooth and suede-effect microfibre with textile lining",
    sole: "Caramel rubber court sole with stitched sidewall",
    fit: "True to size with a regular fit",
    highlights: ["Breathable perforated toe", "Cushioned removable sockliner"],
  },
  32: {
    lead: "A crisp navy court sneaker with high-contrast white panels and a timeless athletic shape.",
    design: "Deep navy sections define the side profile, while white laces and a cream outsole keep the finish fresh and versatile.",
    wear: "A supportive heel cup and softly padded tongue provide dependable comfort for everyday movement.",
    material: "Recycled microfibre upper with breathable mesh lining",
    sole: "Cream rubber cupsole with navy traction insert",
    fit: "True to size; gently snug at the heel",
    highlights: ["Supportive moulded heel cup", "Padded tongue for lace comfort"],
  },
  33: {
    lead: "A moss and oatmeal retro runner with an expressive layered shape and outdoor-inspired palette.",
    design: "Textured overlays, breathable mesh windows and a rust heel accent create a distinctive heritage-running look.",
    wear: "A sculpted foam midsole and rubber contact zones deliver light cushioning and confident everyday grip.",
    material: "Suede-effect microfibre, open recycled mesh and textile lining",
    sole: "Layered EVA midsole with durable rubber tread",
    fit: "True to size with a secure midfoot",
    highlights: ["Layered shock-absorbing midsole", "Ventilated mesh panels"],
  },
  34: {
    lead: "A plum retro sneaker that adds rich colour to a balanced, running-inspired silhouette.",
    design: "Plum overlays sit over pale mesh panels, with cream laces and a layered sole softening the contrast.",
    wear: "Lightweight cushioning and a stabilised heel make this an easy option for long walks and casual days.",
    material: "Plum suede-effect microfibre and recycled performance mesh",
    sole: "Cushioned EVA midsole with plum rubber tread",
    fit: "True to size with medium-volume cushioning",
    highlights: ["Stabilised heel platform", "Breathable performance mesh"],
  },
  35: {
    lead: "A modern black penny loafer set on a lightweight lug sole for a sharper everyday uniform.",
    design: "Matte grain, precise apron stitching and a clean saddle strap keep the chunky silhouette refined rather than heavy.",
    wear: "A padded heel and flexible forefoot support commuting and all-day office wear.",
    material: "Grained black microfibre with recycled textile lining",
    sole: "Lightweight black lugged rubber sole",
    fit: "True to size; comfortable with lightweight socks",
    highlights: ["Soft anti-slip heel lining", "Flexible front sole grooves"],
  },
  36: {
    lead: "A deep wine tassel loafer offering a richer, more decorative take on the city slip-on.",
    design: "A softly polished finish, moccasin-style seam and compact tassels bring texture to the clean rounded shape.",
    wear: "The supportive low sole and cushioned insole make it suitable for work, travel and evening occasions.",
    material: "Polished wine microfibre with smooth recycled lining",
    sole: "Low-profile dark rubber lug sole",
    fit: "True to size with a secure instep",
    highlights: ["Hand-finished moccasin seam", "Cushioned full-length insole"],
  },
  37: {
    lead: "An oxblood cap-toe Derby with formal proportions and a confident contemporary sole.",
    design: "Subtle polish highlights the toe cap and five-eyelet lacing, while tonal edging keeps the deep red finish sophisticated.",
    wear: "Structured heel support and measured cushioning provide comfort for ceremonies, workdays and dinners.",
    material: "Polished oxblood microfibre with breathable woven lining",
    sole: "Dark welt-effect rubber sole with stable low heel",
    fit: "Runs slightly large; size down for a close fit",
    highlights: ["Classic stitched toe cap", "Supportive structured heel"],
  },
  38: {
    lead: "A deep espresso Derby with restrained shine and a versatile plain-toe construction.",
    design: "Slim tonal laces and understated quarters create a clean dress-shoe profile that works with tailoring or dark denim.",
    wear: "Flexible forefoot construction and a padded sockliner reduce fatigue during long days.",
    material: "Smooth espresso microfibre with moisture-managing textile lining",
    sole: "Lightweight dark rubber sole with welt detail",
    fit: "Runs slightly large with a roomy toe",
    highlights: ["Flexible forefoot channels", "Padded moisture-wicking sockliner"],
  },
  39: {
    lead: "A sleek black ankle boot defined by a rounded-square toe and sculptural block heel.",
    design: "The minimal upper and hidden inside zip keep the silhouette uninterrupted, polished and easy to style.",
    wear: "A broad heel base and cushioned forefoot support stable, comfortable wear across the day.",
    material: "Smooth black microfibre with brushed recycled-textile lining",
    sole: "Non-slip rubber outsole with geometric block heel",
    fit: "True to size; streamlined through the ankle",
    highlights: ["Hidden inside zip", "Cushioned forefoot and heel pads"],
  },
  40: {
    lead: "A wine-toned ankle boot with a curved centre seam and a grounded low block heel.",
    design: "The rich matte colour and matching wrapped heel give the clean silhouette a distinctive tonal finish.",
    wear: "Soft ankle lining and a stable heel make it practical for day-to-evening dressing.",
    material: "Matte wine microfibre with soft brushed lining",
    sole: "Flexible rubber outsole with wrapped block heel",
    fit: "True to size with a comfortable ankle opening",
    highlights: ["Easy side-zip entry", "Soft-touch ankle lining"],
  },
  41: {
    lead: "A versatile black Mary Jane with a rounded toe and a subtly flared low heel.",
    design: "A slim buckle strap and clean matte upper keep the familiar silhouette modern and understated.",
    wear: "The cushioned forefoot and adjustable fastening create a secure fit for workdays and evenings.",
    material: "Smooth black microfibre with recycled textile lining",
    sole: "Non-slip flexible rubber sole with low flared heel",
    fit: "True to size; adjustable across the instep",
    highlights: ["Adjustable buckle strap", "Soft forefoot cushioning"],
  },
  42: {
    lead: "A warm amber slingback that pairs a rounded toe with a compact sculpted heel.",
    design: "Delicate strap detailing adds definition while the matte finish keeps the colour soft and wearable.",
    wear: "An adjustable back strap and balanced low heel support comfortable occasion dressing.",
    material: "Amber microfibre upper with smooth recycled lining",
    sole: "Flexible rubber sole with sculpted low heel",
    fit: "True to size; adjustable slingback strap",
    highlights: ["Adjustable slingback closure", "Cushioned toe and heel contact points"],
  },
  43: {
    lead: "A stone-grey flexible sneaker created around natural movement and a roomy anatomical shape.",
    design: "A softly textured knit upper and pale oatmeal sole produce a calm, tonal everyday look.",
    wear: "The wide toe box and thin segmented sole encourage natural flex while the removable footbed adds light cushioning.",
    material: "Recycled stretch knit with microfibre heel reinforcement",
    sole: "Ultra-flexible oatmeal rubber sole with fine siping",
    fit: "Wide fit; true to size in length",
    highlights: ["Anatomical wide toe box", "Highly flexible segmented outsole"],
  },
  44: {
    lead: "A breathable navy flex sneaker with a low profile and extra room through the forefoot.",
    design: "Mesh panels and tonal microfibre supports create structure without adding unnecessary weight or bulk.",
    wear: "A thin responsive sole and softly padded heel suit travel, light movement and daily walking.",
    material: "Breathable recycled mesh with navy microfibre support panels",
    sole: "Thin white segmented rubber sole",
    fit: "Wide fit with a secure, low-volume heel",
    highlights: ["Lightweight breathable construction", "Low-drop flexible sole"],
  },
  45: {
    lead: "A sage trail sneaker designed for light hikes, mixed city routes and active weekends.",
    design: "Ripstop textile, cream guards and a quick-lace system create a technical profile in a soft natural palette.",
    wear: "A stabilised midsole and multidirectional tread provide support and grip without the weight of a traditional hiking shoe.",
    material: "Recycled ripstop textile with suede-effect microfibre guards",
    sole: "Cushioned EVA midsole with high-grip tan rubber lugs",
    fit: "True to size; secure through heel and midfoot",
    highlights: ["Quick-adjust toggle lacing", "Protective toe and heel guards"],
  },
  46: {
    lead: "A burgundy trail sneaker balancing rugged traction with a rich, city-friendly colour.",
    design: "Layered mesh and suede-effect panels protect high-wear areas, while secure lacing locks the midfoot in place.",
    wear: "A padded collar, shock-absorbing midsole and grippy rubber base support longer walks over varied ground.",
    material: "Recycled performance mesh and suede-effect microfibre",
    sole: "Dual-density foam and black rubber trail outsole",
    fit: "True to size with a supportive midfoot wrap",
    highlights: ["Padded trail collar", "Multidirectional traction pattern"],
  },
  47: {
    lead: "A minimalist cream sneaker with tonal details and a softly structured everyday profile.",
    design: "Precise panel lines, flat cotton laces and a monochrome cupsole create a clean look without visible branding.",
    wear: "Balanced cushioning and a flexible sole make it an easy choice for commuting, travel and relaxed weekends.",
    material: "Smooth recycled microfibre with breathable textile lining",
    sole: "Monochrome off-white rubber cupsole",
    fit: "True to size with a regular toe box",
    highlights: ["Tonal low-profile construction", "Removable cushioned insole"],
  },
  48: {
    lead: "A muted rose sneaker that brings soft colour to a simple, low-profile everyday shape.",
    design: "A cream suede-effect toe guard and tonal stitched panels add subtle contrast while preserving the minimal silhouette.",
    wear: "The lightly padded collar and flexible rubber sole keep it comfortable for regular daily use.",
    material: "Matte rose microfibre and cream suede-effect microfibre",
    sole: "Flexible off-white rubber cupsole",
    fit: "True to size; softly padded around the ankle",
    highlights: ["Contrast suede-effect toe guard", "Soft padded ankle collar"],
  },
  49: {
    lead: "A cocoa Chelsea boot with clean lines, easy pull-on construction and a dependable city sole.",
    design: "Dark elastic side panels and a rear pull tab break up the warm matte upper while preserving the streamlined shape.",
    wear: "A cushioned footbed and modest heel make it comfortable for commuting and cool-weather everyday wear.",
    material: "Matte cocoa microfibre with elastic gore and textile lining",
    sole: "Ridged dark-brown rubber sole with low heel",
    fit: "True to size; fitted at the ankle with elastic give",
    highlights: ["Stretch side gore", "Reinforced rear pull tab"],
  },
  50: {
    lead: "A streamlined black Chelsea boot set on a sturdy lug sole for wet-weather city use.",
    design: "A sculpted side panel, rounded toe and monochrome finish keep the robust construction sharp and versatile.",
    wear: "Elastic entry, heel cushioning and a supportive tread make it practical for long days and changing conditions.",
    material: "Smooth black microfibre with elastic gore and recycled lining",
    sole: "Sturdy non-slip black rubber lug sole",
    fit: "True to size with a secure ankle fit",
    highlights: ["Elastic pull-on construction", "Deep wet-weather traction"],
  },
};

const coreFootwear = allProductData.filter(
  (product) => product.category === "Shoes & Boots"
);

const footwearVariants = footwearVariantSpecs.map((spec, index) => {
  const base = coreFootwear.find((product) => product.id === spec.baseId);
  return {
    ...base,
    ...spec,
    category: "Shoes & Boots",
    description: [spec.description],
    reviews: String(24 + index * 3),
    rating: (4.5 + (index % 5) * 0.1).toFixed(1),
    tags: [...(base.tags || []), "footwear"],
    badge: index % 7 === 0 ? "New" : undefined,
  };
});

// The shared catalogue powers shop, recommendations, cart, and checkout.
const productData = [...coreFootwear, ...footwearVariants].map((product) => {
  const editorial = footwearEditorial[product.id];
  if (!editorial) return product;

  return {
    ...product,
    description: [editorial.lead, editorial.design, editorial.wear],
    material: editorial.material,
    attributes: {
      ...(product.attributes || {}),
      material: editorial.material,
      sole: editorial.sole,
      fit: editorial.fit,
    },
    Features: [
      ...editorial.highlights,
      `Upper: ${editorial.material}`,
      `Sole: ${editorial.sole}`,
      `Fit: ${editorial.fit}`,
      "Care: Wipe clean with a soft damp cloth and air dry away from direct heat",
      "Designed in London and produced in carefully selected partner workshops",
    ],
  };
});

export default productData;
